// extracted by mini-css-extract-plugin
module.exports = {"dotted-partition":"styles_dotted-partition__29ZYW","contact-us":"styles_contact-us__3TahV","img-block":"styles_img-block__3LIzJ"};